import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	feedback: {
		id: 'business-issue-field-statistics.sidebar.feedback-button.feedback',
		defaultMessage: 'Give feedback',
		description: 'Button that opens the feedback dialog.',
	},
});
